import userService from '@/service/userService'
import un from 'underscore'

const DEFAULT_SERVICES_VIEW = "servicesList"
const ROLE_PHONE_SERVICES_VIEWS = [DEFAULT_SERVICES_VIEW, "servicesEdit"]


const RoutingService = function() {

    function handleUserPhoneServicesView(to, next) {
        if (un.indexOf(ROLE_PHONE_SERVICES_VIEWS, to.name) !== -1) {
            next()
        } else {
            redirect(next, DEFAULT_SERVICES_VIEW)
        }
    }

    function handleLoggedView(to, next) {
        if (userService.isAdmin()) {
            next()
            return
        }
        if (userService.isUser()) { //should be fixed to check view, info about permission should be added in view definition?
            next()
            return
        }
        if (userService.isUserPhoneServices()) {
            handleUserPhoneServicesView(to, next)
            return
        }
        console.log("Not known user type. Logout")
        userService.logOut()
        redirect(next, "login")
    }

    this.beforeRoute = function(to, from, next) {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (userService.isNotLogged()) {
                redirect(next, "login")
            } else {
                handleLoggedView(to, next)
            }
        } else {
            next()
        }
    }

    function redirect(next, name) {
        next({
            name: name
        })
    }

    return {
        "beforeRoute": this.beforeRoute
    }
}

export default RoutingService;



// WEBPACK FOOTER //
// ./src/router/RoutingService.js